<template>
  <div>
    <v-sheet elevation="2" color="#57bc90" style="min-height: 70vh">
      <v-col cols="12" md="12" sm="12">
        <p class="text-h5 white--text font-weight-bold mt-3">Game Logs</p>
        <div>
          <v-data-table
            :headers="dynamicHeader"
            :items="stats"
            class="elevation-1"
            hide-default-footer
            sort-by="Day"
            sort-desc
            mobile-breakpoint="0"
          >
            <!-- Date -->
            <template v-slot:item.Day="{ item }">
              <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
            </template>
            <!-- Date -->
            <!-- $ per pts -->
          </v-data-table>
        </div>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "MlbfullStats",
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
    Position: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    dynamicHeader() {
      if (this.stats !== null) {
        if (this.Position.position.includes("P")) {
          return this.PitcherHeaders;
        } else {
          return this.HitterHeaders;
        }
      }
    },
  },

  data() {
    return {
      HitterHeaders: [
        {
          text: "Season",
          value: "Season",
        },
        {
          text: "Team",
          value: "Team",
        },
        {
          text: "AB",
          value: "AtBats",
        },
        {
          text: "R",
          value: "Runs",
        },
        {
          text: "H",
          value: "Hits",
        },
        {
          text: "2B",
          value: "Doubles",
        },
        {
          text: "3B",
          value: "Triples",
        },
        {
          text: "HR",
          value: "HomeRuns",
        },
        {
          text: "RBI",
          value: "RunsBattedIn",
        },
        {
          text: "SO",
          value: "Strikeouts",
        },
        {
          text: "SB",
          value: "StolenBases",
        },
        {
          text: "CS",
          value: "CaughtStealing",
        },
        {
          text: "AVG",
          value: "BattingAverage",
        },
        {
          text: "OBP",
          value: "OnBasePercentage",
        },
        {
          text: "SLG",
          value: "SluggingPercentage",
        },
        {
          text: "OPS",
          value: "OnBasePlusSlugging",
        },
        {
          text: "Started",
          value: "Started",
        },
      ],

      PitcherHeaders: [
        {
          text: "Season",
          value: "Season",
        },
        {
          text: "Team",
          value: "Team",
        },
        {
          text: "W",
          value: "Wins",
        },
        {
          text: "L",
          value: "Losses",
        },
        {
          text: "ERA",
          value: "EarnedRunAverage",
        },
        { text: "SV", value: "Saves" },
        {
          text: "IP",
          value: "InningsPitchedFull",
        },
        {
          text: "H",
          value: "PitchingHits",
        },
        {
          text: "R",
          value: "PitchingRuns",
        },
        {
          text: "ER",
          value: "PitchingEarnedRuns",
        },
        {
          text: "HR",
          value: "PitchingHomeRuns",
        },
        {
          text: "BB",
          value: "PitchingWalks",
        },
        {
          text: "SO",
          value: "PitchingStrikeouts",
        },
        {
          text: "Avg",
          value: "PitchingBattingAverageAgainst",
        },
        {
          text: "WHIP",
          value: "WalksHitsPerInningsPitched",
        },
      ],
    };
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
